import { ComponentHelper, ControlHelper, ConditionsHelper, ConfigHelper, ActionHelper, OutputsHelper, SharedJourneyHelper, RedirectHelper, Authenticate } from '../helpers';
import { loadJourneyFromId } from '../helpers/rehydration';
import { Promise } from 'es6-promise';
import store from '../store/store';
import types from '../store/types';

export class InitialisationHelper {

    public static ConfigSettings: any;

	/**
	 * Initialize all designer dependencies and update loading state.
	 * 
	 * @static
	 * @param {string} journeyId Journey ID string (from URL hash).
	 * @returns {Promise<any>} 
	 * 
	 * @memberOf InitialisationHelper
	 */
    public static init(journeyId: string): Promise<any> {

        // Make sure the current state is loading
        store.dispatch({ type: types.SET_LOADING, loading: true });

        var promise = new Promise((resolve, reject) => {

            // Load URLS from config
            ConfigHelper
                .loadAuthenticationSettings()
                .then(settings => {
                    InitialisationHelper.setConfigSettings(settings);
                    return Authenticate(settings);
                })
                .then(token => {
                    return ConfigHelper.loadUrls();
                })
                .then(urls => {

                    // Load templates
                    Promise
                        .all([
                            ComponentHelper.loadComponentTemplateOptions(),
                            ControlHelper.loadControlTypes(),
                            ConditionsHelper.loadOperatorOptions(),
                            ActionHelper.loadActionTypes(),
                            ActionHelper.loadActionTemplate("Set Global Output Value"), // this template is required for io.addSharedJourneyActions() method.
                            ActionHelper.loadActionTemplate("Create Journey Answers"),
                            ActionHelper.getFieldTypes(),
                            OutputsHelper.GetTemplates(),
                            SharedJourneyHelper.cacheAvailableSharedJourneys(),
                            RedirectHelper.loadCandidateTemplates(),
                            loadJourneyFromId(journeyId),
                        ]).then(() => {

                            return SharedJourneyHelper.resolveSharedJourneyOutputs();

                        }).then(() => {

                            // Loading completed
                            store.dispatch({ type: types.SET_LOADING, loading: false });
                            resolve();

                        });

                })
                .catch((error) => {
                    reject(error);
                });

        });

        return promise;

    }

    public static setConfigSettings(settings: any): void {
        InitialisationHelper.ConfigSettings = settings;
    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/initialisation.ts